import Glide from '@glidejs/glide';
import Vue from 'vue';
import VueCardFormat from 'vue-credit-card-validation/src';
import store from './store';
import moment from 'moment';
import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Navbar from './components/Navbar';
import PopOpenBox from './components/PopOpenBox';
import PopOpenLink from './components/PopOpenLink';
import Tabs from './components/Tabs';
import Tab from './components/Tab';
import LoginForm from './components/LoginForm';
import ContactForm from './components/ContactForm';
import FreeTrialForm from './components/FreeTrialForm';
import ConventionInfoForm from './components/ConventionInfoForm';
import VCalendar from 'v-calendar';
import ReviewSchedule from '../assets/js/components/ReviewSchedule';
import Modal from '../assets/js/components/Modal';
import CreateAccountForm from './components/CreateAccountForm';
import CartCheckout from './components/CartCheckout';
import RDContactList from '../assets/js/components/RDContactList';
import EducatorsRequestAccountForm
  from './components/EducatorsRequestAccountForm';
import PromoBanner from './components/PromoBanner';
import PromoOverlay from './components/PromoOverlay';
import LeadForm from './components/LeadForm';
import BookstoreRedemption from './components/BookstoreRedemption';
import HealthcareRegistration from './components/HealthcareRegistration';
import HurstNextPromoRegistration
  from './components/HurstNextPromoRegistration';
import HeaderMenu from "./components/HeaderMenu";
import Footer from "./components/Footer";
import Cart from './components/Cart';
import CartProgress from './components/CartProgress.vue';
import CartButton from "./components/CartButton.vue";
import ErrorAlert from "./components/ErrorAlert.vue";
import PrismicVue from '@prismicio/vue';
import Promotions from "./components/Promotions.vue";

import { VueReCaptcha } from 'vue-recaptcha-v3';

const endpoint = 'https://hurst-review.cdn.prismic.io/api/v2';

Bugsnag.start({
    apiKey: '2fc1399bb441fc11cf19dd48175ec853',
    plugins: [new BugsnagPluginVue()],
    releaseStage: window.releaseStage
});

Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);

window.axios = axios;
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common = {
        'X-CSRF-TOKEN': token.content,
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
    };
}else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

Vue.filter('date', (dateStr, format='LL') => {
    dateStr = dateStr + " 12:00:00";
    return moment(dateStr, "YYYY-MM-DD HH:mm:SS").format(format);
});

Vue.use(VCalendar);
Vue.use(VueCardFormat);
Vue.use(VueReCaptcha, { siteKey: '6LfjgD4oAAAAANkZzyTDusefm63rGy-oMOCvGgDq' });
Vue.use(PrismicVue, {
    endpoint
})
Vue.component('nav-bar', Navbar);
Vue.component('pop-open-box', PopOpenBox);
Vue.component('pop-open-link', PopOpenLink);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('login-form', LoginForm);
Vue.component('contact-form', ContactForm);
Vue.component('free-trial-form', FreeTrialForm);
Vue.component('convention-info-form', ConventionInfoForm);
Vue.component('review-schedule', ReviewSchedule);
Vue.component('modal', Modal);
Vue.component('create-account-form', CreateAccountForm);
Vue.component('cart-checkout', CartCheckout);
Vue.component('rd-contact-list', RDContactList);
Vue.component('edu-request-account', EducatorsRequestAccountForm);
Vue.component('promo-banner', PromoBanner);
Vue.component('promo-overlay', PromoOverlay);
Vue.component('lead-form', LeadForm);
Vue.component('bookstore-redemption', BookstoreRedemption);
Vue.component('hurst-next-promo-registration', HurstNextPromoRegistration);
Vue.component('healthcare-registration', HealthcareRegistration);
Vue.component('header-menu', HeaderMenu);
Vue.component('footer-menu', Footer);
Vue.component('Cart', Cart);
Vue.component('cart-progress', CartProgress);
Vue.component('cart-button', CartButton);
Vue.component('error-alert', ErrorAlert);
Vue.component('promotions', Promotions);
new Vue({
    el: '#app',
    store
});

if (document.getElementsByClassName('testimonials').length > 0) {
    new Glide('.testimonials', {
        type: 'carousel',
        startAt: 0,
        perView: 4,
        autoplay: false,
        animationTimingFunc: 'ease-in-out',
        breakpoints: {
            700: {
                perView: 1,
            },
            900: {
                perView: 2
            },
            1280: {
                autoplay: 7000,
                perView: 3
            },
        },
    }).mount();
}
if (document.getElementsByClassName('know-us').length > 0) {
    new Glide('.know-us', {
        type: 'slider',
        startAt: 0,
        perView: 3,
        breakpoints: {
            650: {
                perView: 1
            },
            900: {
                perView: 2
            }
        },
        autoplay: false,
        animationTimingFunc: 'ease-in-out'
    }).mount();
}
if (document.getElementsByClassName('choose-review').length > 0) {
    new Glide('.choose-review', {
        type: 'carousel',
        startAt: 0,
        perView: 5,
        breakpoints: {
            700: {
                perView: 1,
                startAt: 5,
            },
            900: {
                perView: 2,
                startAt: 0
            },
            1024: {
                perView: 3,
                startAt: 2
            },
            1500: {
                perView: 4,
                startAt: 2
            }
        },
        autoplay: false,
        animationTimingFunc: 'ease-in-out'
    }).mount();
}

